import { render, staticRenderFns } from "./ReserveContent.vue?vue&type=template&id=04974b88"
import script from "./ReserveContent.vue?vue&type=script&lang=js"
export * from "./ReserveContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports